import { assetUrl } from "fusion-core";
import Accordion from "../../../shared/components/accordion";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { useForm } from "react-hook-form";
import QuoteFormWrapper from "../../../shared/components/quoteFormWrapper";
import QuoteStepHeading from "../../../shared/components/QuoteStepHeading";
import QuoteStepLoader from "../../../shared/components/QuoteStepLoader";
import FormNavigationButtons from "../../../shared/components/FormNavigationButtons";
import BuyStep from "../enums/BuyStep";
import { handleNext } from "../../../shared/utils/navigationUtils";
import useQuoteStore from "../../quote/store/QuoteStore";
import { useNavigate } from "fusion-plugin-react-router";
import { fetchPaymentOptions } from "../services/buyService";
import useBuyStore from "../store/BuyStore";
import { TAXI_QUOTE_BRANDREF } from "../../../config/config";
import { useEffect, useState } from "react";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { HotjarEventNames } from "../../../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../../../shared/utils/trackHotjarEvent";

const TbDocuments = () => {
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm();

  let STATE = useAppStateStore();

  const navigate = useNavigate();
  const buyStore = useBuyStore.getState();
  const main = assetUrl("../../../styles/main.css");
  const riskObjectId = useQuoteStore.getState().quote?.risk?.riskObjectId;
  const brandRef = TAXI_QUOTE_BRANDREF;

  const [loadingStates, setLoadingStates] = useState({});

  useEffect(() => {
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TBDOCUMENTS_ENTERED);
  }, []);

  const onSubmit = async (data) => {
    STATE.setPaymentsLoading(true);
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TBDOCUMENTS_NEXT_CLICKED);

    const paymentOptionsRequestBody = {
      brandRef: brandRef,
      RiskObjectId: riskObjectId || null,
      RiskObjectHistoryId: 1,
    };

    buyStore.setObject("paymentOptionsRequestBody", paymentOptionsRequestBody);

    try {
      await fetchPaymentOptions(paymentOptionsRequestBody, navigate);
      handleNext(BuyStep.TB_E_PAYMENT, STATE);
    } catch (error) {
      console.error("Error fetching payment options:", error);
    } finally {
      STATE.setPaymentsLoading(false);
    }
  };

  const documents =
    buyStore.getObject("vaultResponse")?.templateItems?.map((item) => ({
      title: item.templateItemDescription,
      link: item.templateDocumentGetUrl,
      linkDescription: item.templateExplanation,
      webDownloadFileName: item.webDownloadFileName.split(".")[0],
    })) || [];

  if (STATE.paymentsLoading) {
    return (
      <QuoteStepLoader
        title="Price breakdown"
        description="We're preparing the payment options available for your quote."
        message="Fetching your payment options..."
      />
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={main} />
      </Helmet>
      <QuoteFormWrapper>
        <div>
          <QuoteStepHeading
            title="Your Documents"
            description="Please take your time to read through and understand your documents."
          />
          {documents.map((doc, index) => (
            <Accordion
              key={index}
              title={doc.title}
              link={doc.link}
              linkDescription={doc.linkDescription}
              isLoading={loadingStates[index] || false}
              setLoading={(isLoading) =>
                setLoadingStates((prev) => ({ ...prev, [index]: isLoading }))
              }
              name={doc.webDownloadFileName}
            />
          ))}

          <div className="tw-mt-8 tw-flex tw-items-start tw-gap-3">
            <input
              type="checkbox"
              className="tw-landing-native-checkbox tw-mt-1 tw-h-5 tw-w-5 tw-shrink-0 tw-cursor-pointer tw-accent-dis-deep-blue"
              id="docTermsAccepted"
              {...register("docTermsAccepted", {
                required:
                  "You cannot proceed to purchase without confirming acceptance and understanding of our Terms of Business and your policy documents.",
              })}
            />
            <label htmlFor="docTermsAccepted" className="tw-m-0 tw-cursor-pointer tw-text-base tw-leading-6 tw-text-dis-text">
              I have read and understood my policy documents and agree to the
              terms of business.
            </label>
            {errors.docTermsAccepted && (
              <span className="tw-block tw-text-dis-small tw-text-dis-error">
                {errors.docTermsAccepted.message}
              </span>
            )}
          </div>
        </div>
      </QuoteFormWrapper>

      <FormNavigationButtons
        prevStep={BuyStep.TB_ADDON_RECOMMENDATIONS}
        isValid={isValid}
      />
    </form>
  );
};

export default TbDocuments;
